<template>
  <div id="app">
    <SiteIndex/>
  </div>
</template>

<script>
import SiteIndex from './components/SiteIndex'

export default {
  name: 'App',
  components: {
    SiteIndex
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue